import * as React from 'react'

import { Skeleton } from '@thg-commerce/gravity-elements'
import { spacing, styled } from '@thg-commerce/gravity-theme'
import { ProductItemSkeleton } from '@thg-commerce/enterprise-widget-product-list-page/src/ProductItem'

const Title = styled(Skeleton)`
  height: 16px;
  width: 20%;
  margin: ${spacing(4)} 0 ${spacing(4)} 40%;
`

const DesktopContainer = styled.ul`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
`

export const RecentlyViewedProductRailSkeleton = () => {
  return (
    <React.Fragment>
      <Title />
      <DesktopContainer>{ProductItemSkeleton(2)}</DesktopContainer>
    </React.Fragment>
  )
}
